import React from "react";
import { Text } from "basis";

import Link from "../../Link";
import { currencyFormat } from "../../../utils";
import { FEES, MONTHLY_FEES, RATES } from "./constants";

export const Minimum = ({
  onLearnMoreClick = () => { },
  currency,
  learnMoreURL,
  au,
  nz,
}) => {
  const monthlyPrice = currencyFormat(MONTHLY_FEES[currency]);

  const AU = () => (
    <>
      <Text textStyle="body2" margin="0 0 3">
        <strong>
          Pay your credit card minimum payment each month.
        </strong>
      </Text>

      <Text textStyle="body2" margin="0 0 3">
        Paying this way may not clear the plan within your plan period. Interest will charged at the Expired Plan Rate of {RATES.GEM_VISA_AU}% p.a. (subject to change) on any outstanding balance at the end of your plan period. Monthly credit card fee of {monthlyPrice} per month applies (subject to change).
      </Text>

      {!window.location.pathname.includes('/payment/complete') && (
        <Link onClick={onLearnMoreClick} href={learnMoreURL} newTab smallFont>
          Learn more
        </Link>
      )}
    </>
  );

  const NZ = () => (
    <>
      <Text textStyle="body2" margin="0 0 3">
        <strong>
         Pay your credit card minimum payment each month.
        </strong>
      </Text>

      <Text textStyle="body2" margin="0 0 3">
        Paying only the minimum monthly payment will not pay out the purchase before the end of the plan. Lending criteria, T&C's and fees apply including a
        ${FEES.ESTABLISHMENT} establishment fee  &amp; ${FEES["GEM_VISA"]} annual fee ($
        {FEES["GEM_VISA_HALF_YEARLY"]} half yearly ).
        Standard interest rate
        (currently {RATES.GEM_VISA_NZ}% p.a.)
        applies after interest free term ends.
      </Text>

       {!window.location.pathname.includes('/payment/complete') && (
        <Link onClick={onLearnMoreClick} href={learnMoreURL} newTab smallFont>
          Learn more
        </Link>
      )}
    </>
  );

  return (
    <>
      {au && <AU />}
      {nz && <NZ />}
    </>
  );
};
